import React from "react";
import styled from "styled-components";

import { Button } from "react-bootstrap";

const RegisterButton = styled(Button)`
    padding-top: 15px !important
    padding-bottom: 15px !important
    border-radius: 15px !important
    background: #cfefff
    width: 100%
    > span {
        font-size: 1.2em !important
        color: #4bace0 !important
        font-weight: bold
    }
    :hover{
        background: #cfefff
    }
    :focus{
        background: #cfefff
    }
`;
export default RegisterButton;



// WEBPACK FOOTER //
// ./src/views/Auth/components/RegisterButton/index.jsx